import { ArrowRight, AlertTriangle } from "lucide-react";
import { NativeSelect } from "@/components/common";

// Left: detected file headers. Right: the PressOps field each header feeds.
export function ColumnMapper({ session, onChange, disabled }) {
  const { headers, mapping, fields, missing_required: missing, sample } = session;
  const used = new Set(Object.values(mapping).filter(Boolean));
  const label = Object.fromEntries(fields.map((f) => [f.key, f.label]));
  const options = (h) => fields.filter((f) => f.key === mapping[h] || !used.has(f.key)).map((f) => ({ value: f.key, label: `${f.label}${f.required ? " *" : ""}` }));
  return (
    <div className="space-y-3" data-testid="column-mapper">
      {missing.length > 0 && (
        <div className="flex items-start gap-2 rounded-lg border px-3 py-2 text-sm po-tone-danger" data-testid="mapper-missing-required">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
          <span>Map these required fields before importing: <strong>{missing.map((k) => label[k]).join(", ")}</strong></span>
        </div>
      )}
      <div className="overflow-x-auto"><table className="po-table">
        <thead><tr><th>Column in your file</th><th>Example</th><th></th><th>PressOps field</th></tr></thead>
        <tbody>{headers.map((h, i) => (
          <tr key={h} data-testid={`mapper-row-${i}`}>
            <td className="font-medium" data-testid={`mapper-header-${i}`}>{h}</td>
            <td className="max-w-[220px] truncate text-slate-500">{sample.map((r) => r[i]).filter(Boolean)[0] || "—"}</td>
            <td><ArrowRight className="h-4 w-4 text-slate-400" /></td>
            <td><NativeSelect testId={`mapper-select-${i}`} className={mapping[h] ? "" : "text-slate-400"} value={mapping[h]} placeholder="Don't import"
              options={options(h)} onChange={(v) => !disabled && onChange({ ...mapping, [h]: v })} /></td>
          </tr>))}</tbody>
      </table></div>
      <p className="text-xs text-slate-500">Fields marked * are required. Matching columns were filled in for you; change any that look wrong.</p>
    </div>
  );
}
